import styled, { css } from 'styled-components';

export const Field = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  background-color: var(--bg);
  border: 1px solid var(--bg-4);
  padding: var(--xs-padding);
  word-break: break-all;
`;

export const Content = styled.div``;

export const CopyButton = styled.button`
  border: none;
  background: transparent;
  border-radius: 5px;
  color: var(--text);
  margin-left: var(--xs-padding-horizontal);

  :hover {
    background-color: var(--bg-1);
  }

  > svg {
    ${({ copied }) =>
      copied &&
      css`
        color: var(--green);
      `}
  }
`;
